<h3 mat-dialog-title class="title">{{ data.title }}</h3>
<mat-dialog-content class="body">{{ data.message }}</mat-dialog-content>
@if (!data.timeout) {
  <mat-dialog-actions class="footer" align="end">
    @if (data.button1) {
      <div>
        @switch (data.button1.style.stroked) {
          @case (true) {
            <button
              mat-button mat-stroked-button
              [color]="data.button1.style.color"
              (click)="onButton1Click()"
            >{{ data.button1.text }}</button>
          }
          @default {
            <button
              mat-button mat-raised-button
              [color]="data.button1.style.color"
              (click)="onButton1Click()"
            >{{ data.button1.text }}</button>
          }
        }
      </div>
    }
    @if (data.button2) {
      <div>
        @switch (data.button2.style.stroked) {
          @case (true) {
            <button
              mat-button mat-stroked-button
              [color]="data.button2.style.color"
              (click)="onButton2Click()"
            >{{ data.button2.text }}</button>
          }
          @default {
            <button
              mat-button mat-raised-button
              [color]="data.button2.style.color"
              (click)="onButton2Click()"
            >{{ data.button2.text }}</button>
          }
        }
      </div>
    }
  </mat-dialog-actions>
}
